export const FIREBASE_EDPOINT = 'https://logpwaoops-default-rtdb.europe-west1.firebasedatabase.app/.json';
export const PAGE_HAS_BEEN_FORCE_REFRESHED = 'page-has-been-force-refreshed';
export const PAGE_LOGGED_ERROR = 'page-logged-error';
